import React from "react";

import {
  DashboardHeader,
  DashboardSideBar,
} from "../../components/dashboard/layout";

import {
  CreateReview,
} from "../../components/dashboard";

import {
  useStateContext,
} from "../../context/ContextProvider";


function CreateReviewPage() {
  const {
    activeMenu,
    setActiveMenu,
    currentDir,
    screenSize,
  } = useStateContext();


  const isRTL =
    currentDir === "rtl";


  const isMobile =
    screenSize <= 900;


  return (
    <div
      className="
        relative

        min-h-screen

        overflow-x-hidden

        bg-back-secondary
        dark:bg-back-darkprimery
      "
    >

      {/* =====================================
          HEADER
      ====================================== */}

      <DashboardHeader />


      {/* =====================================
          MOBILE OVERLAY
      ====================================== */}

      {activeMenu &&
        isMobile && (

          <button
            type="button"

            aria-label="Close sidebar"

            onClick={() =>
              setActiveMenu(
                false
              )
            }

            className="
              fixed
              inset-0

              z-[55]

              bg-color-2/55

              backdrop-blur-[2px]

              lg:hidden
            "
          />

        )}


      {/* =====================================
          SIDEBAR
      ====================================== */}

      <aside
        className={`
          fixed

          top-0
          bottom-0

          z-[60]

          w-[286px]

          transition-transform
          duration-500

          ease-[cubic-bezier(.22,1,.36,1)]

          ${
            isRTL
              ? "right-0"
              : "left-0"
          }

          ${
            activeMenu
              ? "translate-x-0"
              : isRTL
              ? "translate-x-full"
              : "-translate-x-full"
          }
        `}
      >
        <DashboardSideBar />
      </aside>


      {/* =====================================
          MAIN
      ====================================== */}

      <main
        className={`
          relative

          min-h-screen

          pt-[78px]

          transition-all
          duration-500

          ${
            activeMenu
              ? `
                lg:ltr:ml-[286px]
                lg:rtl:mr-[286px]
              `
              : ""
          }
        `}
      >

        {/* Glow */}

        <div
          className="
            absolute

            top-0
            end-0

            w-[400px]
            h-[400px]

            rounded-full

            bg-color-1/[0.04]

            blur-[120px]

            pointer-events-none
          "
        />


        <div
          className="
            relative
            z-10

            w-full

            px-4
            sm:px-6
            lg:px-8

            py-8
            lg:py-10
          "
        >
          <CreateReview />
        </div>

      </main>

    </div>
  );
}


export default CreateReviewPage;